/** 组件库前缀 */
export const PREFIX = 'd'
